module.exports = __webpack_public_path__ + "img/operationCapacity4.18ea440c.png";